import {
	ALERTAS_PERMISSIONS,
	CENTRAL_DOACOES_PERMISSIONS,
	DACA_PERMISSIONS,
	PRESTACAO_CONTAS_PERMISSIONS
} from "constants/index";
import { createHashHistory } from "history";
import AnalisePrestacaoContainer from "pages/PrestacaoContas/analisePrestacaoContainer";
import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, Router, Switch } from "react-router-dom";
import { clearUsuario, isAuthenticated } from "services/auth";
import { validatePermission } from "utils/permissionHelper";
import ToastHelper from "utils/toastHelper";
import ListaExpectativaAlerta from "../pages/alertas/ListaExpectativaAlertas/listaexpectativaalerta.page";
import GerenciarDoacoes from "../pages/centralDoacoes/gerenciarDoacoes/gerenciarDoacoes.page";
import Home from "../pages/comum/Home/home.page";
import LayoutContainer from "../pages/comum/Layout/layout.container";
import TabNavigation from "../pages/comum/TabNavigation/tabnavigation.page";
import TabNavigationDoacoes from "../pages/comum/TabNavigation/tabnavigationDoacoes.page";
import TabNavigationVisualizarAlerta from "../pages/comum/TabNavigation/tabnavigationVisualizarAlerta.page";
import GerenciarItemDaca from "../pages/GerenciarItemDaca/gerenciaitemdaca.page";
import ListaDaca from "../pages/ListaDaca/listadaca.page";
import Login from "../pages/login/login.page";
import ListaPrestacoes from "../pages/PrestacaoContas/listaPrestacoes/listaPrestacoes.page";
import AnalisePrestacao from "../pages/PrestacaoContas/prestacaoContasMunicipio/prestacaoContasMunicipio.page";

const mapStateToProps = state => ({ usuario: state.auth.usuario });

export const history = createHashHistory();

history.listen(async location => {
	const { pathname } = location;

	if (pathname !== "/" || pathname !== "") {
		const isAutenticado = await isAuthenticated();

		if (!isAutenticado) {
			clearUsuario();
		}
	}
});

class PrivateRoute extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isAutenticado: true
		};
	}

	componentDidMount() {
		isAuthenticated().then(response => {
			if (!response)
				this.setState({
					isAutenticado: response
				});
		});
	}

	shouldComponentUpdate(next) {
		const { usuario } = next;

		if (!usuario.sub) {
			ToastHelper.error("Sua sessão expirou. Faço o login novamente.");
			history.push({
				pathname: "/"
			});
			return true;
		}

		if (!this.props.permissions) return true;

		if (!validatePermission(this.props.permissions, usuario.soeAcoes)) {
			history.push({
				pathname: "/home"
			});
			return true;
		}

		return true;
	}

	render() {
		const { component: Component, ...rest } = this.props;

		return (
			<Route
				{...rest}
				render={props =>
					this.state.isAutenticado ? (
						<Component {...props} />
					) : (
						<Redirect
							to={{
								pathname: "/",
								state: { from: props.location }
							}}
						/>
					)
				}
			/>
		);
	}
}

const PrivateRouteWithRedux = connect(mapStateToProps)(PrivateRoute);

const Routes = () => (
	<Router history={history}>
		<Switch>
			<Route exact path="/" component={Login} />
			<LayoutContainer>
				<Switch>
					<PrivateRouteWithRedux path="/home" component={Home} />

					<PrivateRouteWithRedux
						path="/alerta/:page/:id"
						component={TabNavigation}
						permissions={[ALERTAS_PERMISSIONS.VISUALIZAR]}
					/>

					<PrivateRouteWithRedux
						path="/visualizarAlerta"
						component={TabNavigationVisualizarAlerta}
						permissions={[ALERTAS_PERMISSIONS.VISUALIZAR]}
					/>

					<PrivateRouteWithRedux
						path="/alertas"
						component={ListaExpectativaAlerta}
						permissions={[ALERTAS_PERMISSIONS.VISUALIZAR]}
					/>

					<PrivateRouteWithRedux
						exact
						path="/listadaca"
						component={ListaDaca}
						permissions={[DACA_PERMISSIONS.VISUALIZAR]}
					/>

					<PrivateRouteWithRedux
						path="/listadaca/gerenciaitem/:id"
						component={GerenciarItemDaca}
						permissions={[DACA_PERMISSIONS.VISUALIZAR]}
					/>

					<PrivateRouteWithRedux
						path="/centralDoacoes/gerenciadoacao/:id"
						component={GerenciarDoacoes}
						permissions={[CENTRAL_DOACOES_PERMISSIONS.VISUALIZAR]}
					/>

					<PrivateRouteWithRedux
						path="/centralDoacoes"
						component={TabNavigationDoacoes}
						permissions={[CENTRAL_DOACOES_PERMISSIONS.VISUALIZAR]}
					/>

					<PrivateRouteWithRedux
						exact
						path="/prestacaoContas"
						component={ListaPrestacoes}
						permissions={[
							PRESTACAO_CONTAS_PERMISSIONS.LISTAGEM_ESTADUAL,
							PRESTACAO_CONTAS_PERMISSIONS.LISTAGEM_REGINONAL,
							PRESTACAO_CONTAS_PERMISSIONS.LISTAGEM_MUNICIPAL
						]}
					/>

					<PrivateRouteWithRedux
						path="/prestacaoContas/analisar/:id"
						component={AnalisePrestacao}
						permissions={[
							PRESTACAO_CONTAS_PERMISSIONS.ANALISAR_DACA,
							PRESTACAO_CONTAS_PERMISSIONS.ANALISAR_SUB_CHEFE,
							PRESTACAO_CONTAS_PERMISSIONS.ANALISAR_CREPDEC,
							PRESTACAO_CONTAS_PERMISSIONS.PRESTAR_CONTAS
						]}
					/>

					<PrivateRouteWithRedux
						path="/prestacaoContas/:localProcesso/:id"
						component={AnalisePrestacaoContainer}
						permissions={[PRESTACAO_CONTAS_PERMISSIONS.VISUALIZAR]}
					/>

					<Redirect to="/home" component={Home} />
				</Switch>
			</LayoutContainer>
		</Switch>
	</Router>
);

export default Routes;
